import { render, staticRenderFns } from "./PlanContact.vue?vue&type=template&id=18db3928&scoped=true&"
import script from "./PlanContact.vue?vue&type=script&lang=js&"
export * from "./PlanContact.vue?vue&type=script&lang=js&"
import style0 from "./PlanContact.vue?vue&type=style&index=0&id=18db3928&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18db3928",
  null
  
)

export default component.exports